import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {useConfirmDialog} from "@/composable/useConfirmDialog";
import {InformationModal} from ".";

export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmModal',
  setup(__props) {

const {state} = useConfirmDialog();

const agree = () => {
    state.resolve(true);
    state.isOpen = false;
};
const cancel = () => {
    state.resolve(false);
    state.isOpen = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(InformationModal), {
    title: _unref(state).title,
    key: "confirmDialog",
    ref: "confirmDialog",
    modelValue: _unref(state).isOpen,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).isOpen) = $event)),
    "show-footer": true,
    className: "confirm"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        "data-bs-dismiss": "modal",
        onClick: _withModifiers(cancel, ["prevent"])
      }, " No "),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        onClick: _withModifiers(agree, ["prevent"])
      }, " Yes ")
    ]),
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(state).content) + " ", 1)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})